/**
 * Event handlers used by Slate plugins.
 *
 * @type {Array}
 */

const EVENT_HANDLERS = [
  'onBeforeInput',
  'onBlur',
  'onClick',
  'onContextMenu',
  'onCompositionEnd',
  'onCompositionStart',
  'onCopy',
  'onCut',
  'onDragEnd',
  'onDragEnter',
  'onDragExit',
  'onDragLeave',
  'onDragOver',
  'onDragStart',
  'onDrop',
  'onInput',
  'onFocus',
  'onKeyDown',
  'onKeyUp',
  'onMouseDown',
  'onMouseUp',
  'onPaste',
  'onSelect',
]

/**
 * Export.
 *
 * @type {Array}
 */

export default EVENT_HANDLERS
